namespace Matrix.Data {
    export interface CreditRatingRow {
        RatingId?: number;
        RatingFactor?: number;
        SpLong?: string;
        SpShort?: string;
        MoodysLong?: string;
        MoodysShort?: string;
        FitchLong?: string;
        FitchShort?: string;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace CreditRatingRow {
        export const idProperty = 'RatingId';
        export const nameProperty = 'SpLong';
        export const localTextPrefix = 'Data.CreditRating';
        export const lookupKey = 'Data.CreditRating';

        export function getLookup(): Q.Lookup<CreditRatingRow> {
            return Q.getLookup<CreditRatingRow>('Data.CreditRating');
        }
        export const deletePermission = 'DataAdmin:CreditRating';
        export const insertPermission = 'DataAdmin:CreditRating';
        export const readPermission = 'Read:CreditRating';
        export const updatePermission = 'DataAdmin:CreditRating';

        export declare const enum Fields {
            RatingId = "RatingId",
            RatingFactor = "RatingFactor",
            SpLong = "SpLong",
            SpShort = "SpShort",
            MoodysLong = "MoodysLong",
            MoodysShort = "MoodysShort",
            FitchLong = "FitchLong",
            FitchShort = "FitchShort",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
